import { setPageTitle } from '@vip-activity/business/pageSetting';
import env from '@tencent/vft-common/env';
import { playVideo } from '@vip-activity/business/navigate';
import atom from '@tencent/vft-atom';
var _window = window,
    TencentSports = _window.TencentSports;
export * from './share'; // 设置标题

export function setTitle() {
  if (env.isQQSports) {
    var title = window.pageSetting.页面标题;
    TencentSports.setWebViewTitle({
      title: title
    });
  } else {
    setPageTitle();
  }
} // 点播视频

export function playCidVideo(item) {
  if (!item) return;
  var vid = item.vid,
      cid = item.cid;
  if (!vid && !cid) return;
  var param = {
    vid: vid,
    cid: cid
  }; // 腾讯视频

  if (env.isApp) {
    atom.play(param);
  } else if (env.isQQSports) {
    TencentSports.appSdk.openJumpData({
      type: 204,
      param: param
    });
  } else {
    playVideo(param);
  }
} // 获取未中奖的图片文案配置

export function getRandomNoHitConfig() {
  var arr = window.setting.抽奖模块.未中奖素材;
  var index = Math.floor(Math.random() * arr.length);
  return arr[index];
}